// Accelerated picking with three-mesh-bvh. Hover in measure mode raycasts about
// 30x per second; without a BVH every hover tests every triangle of the model.
//
// The BVH is built in "indirect" mode: it keeps its own triangle order and
// leaves the geometry index untouched. That matters because the B-rep face
// ranges (STEP brep_faces, mesh-faces.ts) and the per-colour geometry groups
// are triangle ranges in the original index order.
import * as THREE from 'three';
import { acceleratedRaycast, computeBoundsTree, disposeBoundsTree } from 'three-mesh-bvh';

THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
// Falls back to the normal raycast for geometry without a bounds tree.
THREE.Mesh.prototype.raycast = acceleratedRaycast;

/** Build a bounds tree for every model body (shared geometries are built once). */
export function buildBoundsTrees(root: THREE.Object3D): void {
  root.traverse(obj => {
    const mesh = obj as THREE.Mesh;
    if (!mesh.isMesh || !mesh.userData.isModelBody) return;
    const geometry = mesh.geometry;
    if (!geometry || geometry.boundsTree || !geometry.getAttribute('position')) return;
    geometry.computeBoundsTree({ indirect: true });
  });
}
